var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.881 16.006",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-linejoin: round;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9813",
    "data-name": "Group 9813",
    transform: "translate(0.505 0.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    className: "cls-1",
    y1: 2.26,
    x2: 10.975,
    transform: "translate(5.81 3.874)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    className: "cls-2",
    d: "M13.25,17.14V7.276l10.975-2.26v10.2",
    transform: "translate(-7.44 -5.016)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    className: "cls-2",
    d: "M10.055,22.783c0,.037,0,.074.005.11.012,1.15-1.184,2.366-2.736,2.755-1.6.4-2.976-.23-3.069-1.412s1.129-2.464,2.731-2.866S9.962,21.6,10.055,22.783Z",
    transform: "translate(-4.25 -10.769)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    className: "cls-2",
    d: "M27.055,19.783c0,.041.005.082.005.123,0,1.146-1.19,2.355-2.736,2.743-1.6.4-2.976-.23-3.069-1.412s1.129-2.464,2.731-2.866S26.962,18.6,27.055,19.783Z",
    transform: "translate(-10.275 -9.706)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusic);
export default __webpack_public_path__ + "static/media/music.5617cf80e9c25decc51d93638e49dac1.svg";
export { ForwardRef as ReactComponent };